//reestablecer
function abrirModalPersonalizar() {
  const modal = document.getElementById('custom');
  modal.style.display = 'block';

  const mainImage = document.getElementById("main-image");
  const selectedColorText = document.getElementById("selected-color");
  const textarea = document.getElementById("text-input");
  const textContainer = document.getElementById("text-container");
  const svgBloque = document.getElementById("bloque-svg");

  const estiloMap = {
    "Oswald": "estilo1",
    "Libre Baskerville": "estilo2",
    "Graduate": "estilo3",
    "Dancing Script": "estilo4",
    "Roboto Slab": "estilo5"
  };

  // 1️⃣ Restaurar texto y SVG (si ya hay valores)
  textContainer.innerText = textarea.value;
  const selectedIcon = document.querySelector('input[name="svg-icon"]:checked');
  if (selectedIcon) {
    const icono = document.querySelector('#svgs-ocultos [data-icon="' + selectedIcon.value + '"]');
    if (icono) svgBloque.innerHTML = icono.innerHTML;
  }

  // 2️⃣ Restaurar tipografía
  const tipografia = document.querySelector('input[name="properties[Tipografia]"]:checked');
  textContainer.classList.remove(...Object.values(estiloMap));
  if (tipografia) textContainer.classList.add(estiloMap[tipografia.value]);

  // 3️⃣ Restaurar orientación
  const orientation = document.querySelector('input[name="properties[Orientación]"]:checked');
  textContainer.classList.toggle('vertical', orientation && orientation.value === 'vertical');

  // 4️⃣ Restaurar color/imagen
  let selectedRadio = document.querySelector('input[type="radio"][data-img]:checked');

  // 🔹 Si no hay ninguno seleccionado, marcar automáticamente la primera variante
  if (!selectedRadio) {
    selectedRadio = document.querySelector('input[type="radio"][data-img]');
    if (selectedRadio) selectedRadio.checked = true;
  }

  if (selectedRadio) {
    let url = selectedRadio.getAttribute("data-img");
    if (url.startsWith("//")) url = "https:" + url;
    mainImage.src = url;
    selectedColorText.textContent = selectedRadio.getAttribute("data-color") || "";
  }
}



document.addEventListener("DOMContentLoaded", function () {
    const colorRadios = document.querySelectorAll('input[type="radio"][data-img]');
    const mainImage = document.querySelector('#mi-div img');
    const selectedColorText = document.getElementById("selected-color");

    if (!mainImage) {
        console.error("No se encontró la imagen principal dentro de #mi-div.");
        return;
    }

    // 👇 Normaliza URLs tipo //cdn.shopify.com → https://cdn.shopify.com
    function normalizeUrl(url) {
        if (!url) return "";
        if (url.startsWith("//")) {
            return "https:" + url;
        }
        return url;
    }

    function updateImageAndColor(radio) {
        let newImageUrl = radio.getAttribute("data-img");
        const colorName = radio.getAttribute("data-color");

        if (newImageUrl) {
            newImageUrl = normalizeUrl(newImageUrl); // 👈 FIX IMPORTANTE
            mainImage.src = newImageUrl;
        }

        if (selectedColorText && colorName) {
            selectedColorText.textContent = colorName;
        }
    }

    // Cargar la opción marcada al iniciar
    const checkedRadio = document.querySelector('input[type="radio"][data-img]:checked');
    if (checkedRadio) {
        updateImageAndColor(checkedRadio);
    }

    // Detectar cambios
    colorRadios.forEach(radio => {
        radio.addEventListener("change", function () {
            updateImageAndColor(this);
        });
    });
});



document.getElementById("text-input").addEventListener("input", function () {
      const maxCharsPerLine = 30;
      const maxLines = 15;
      const textContainer = document.getElementById("text-container");

      let text = this.value;
      let lines = text.split("\n"); 
      let formattedLines = [];

      lines.forEach(line => {
        while (line.length > maxCharsPerLine) {
          formattedLines.push(line.slice(0, maxCharsPerLine));
          line = line.slice(maxCharsPerLine);
        }
        formattedLines.push(line);
      });

      // Limitar a 15 líneas
      if (formattedLines.length > maxLines) {
        formattedLines = formattedLines.slice(0, maxLines);
      }

      this.value = formattedLines.join("\n");
      textContainer.innerText = this.value;

      // Ajustar dinámicamente el tamaño de fuente
      fitTextToContainer(textContainer, 60, 7); // max, min
    });

    function fitTextToContainer(el, maxFontSize, minFontSize) {
      let fontSize = maxFontSize;
      el.style.fontSize = fontSize + "px";

      // Reducir tamaño hasta que quepa el contenido
      while ((el.scrollHeight > el.clientHeight || el.scrollWidth > el.clientWidth) && fontSize > minFontSize) {
        fontSize--;
        el.style.fontSize = fontSize + "px";
      }
    }


// Mapeo de nombres de tipografía a clases de estilo
const estiloMap = {
    "Oswald": "estilo1",
    "Libre Baskerville": "estilo2",
    "Graduate": "estilo3",
    "Dancing Script": "estilo4",
    "Roboto Slab": "estilo5"
};

document.querySelectorAll('input[name="properties[Tipografia]"]').forEach(input => {
    input.addEventListener("change", function () {
        const textContainer = document.getElementById("text-container");

        textContainer.classList.remove("estilo1", "estilo2", "estilo3", "estilo4", "estilo5");

        const claseEstilo = estiloMap[this.value];

        if (claseEstilo) {
            textContainer.classList.add(claseEstilo);
        }

        // Esperar unos milisegundos antes de ajustar el tamaño
        setTimeout(() => {
            fitTextToContainer(textContainer, 60, 7);
        }, 20);
    });
});





const labels = document.querySelectorAll('.orientation-option');
  const container = document.getElementById('text-container');

  labels.forEach(label => {
    label.addEventListener('click', () => {
      // Quitar clase "selected" de todos
      labels.forEach(l => l.classList.remove('selected'));
      label.classList.add('selected');

      const orientation = label.dataset.orientation;

      if (orientation === 'vertical') {
        container.classList.add('vertical');
      } else {
        container.classList.remove('vertical');
      }
    });
  });

  // Inicial: marcar el que está checked
  window.addEventListener('DOMContentLoaded', () => {
    const checkedInput = document.querySelector('input[name="properties[Orientación]"]:checked');
    if (checkedInput) {
      checkedInput.closest('.orientation-option').classList.add('selected');
    }
  });

  
function waitForAllImages(container) {
  const images = container.querySelectorAll("img");
  const promises = [];

  images.forEach(img => {
    promises.push(new Promise((resolve, reject) => {
      if (img.complete && img.naturalWidth !== 0) {
        return resolve(); // Ya cargada
      }
      img.onload = () => resolve();
      img.onerror = () => reject(`Error al cargar imagen: ${img.src}`);
    }));
  });

  return Promise.all(promises);
}
async function esperarImagenPrincipal() {
  return new Promise((resolve, reject) => {
    const img = document.getElementById("main-image");

    if (img.complete && img.naturalHeight > 0) {
      resolve();
    } else {
      img.onload = resolve;
      img.onerror = () => reject("No se pudo cargar la imagen principal");
    }
  });
}

// ======================================================
//  GENERACIÓN DE LA IMAGEN
// ======================================================
document.getElementById("generar-imagen").addEventListener("click", async function (e) {
  e.preventDefault();

  const spinner = document.getElementById("loading-spinner");
  spinner.style.display = "block";

  const nodo = document.getElementById("mi-div");

  try {
    // 🟢 Esperar TODAS las imágenes dentro del nodo
    await Promise.all(
      Array.from(nodo.querySelectorAll("img")).map(
        (img) =>
          new Promise((resolve) => {
            if (img.complete && img.naturalHeight !== 0) {
              resolve();
            } else {
              img.onload = resolve;
              img.onerror = () => {
                console.warn("⚠️ Imagen no se pudo cargar:", img.src);
                resolve();
              };
            }
          })
      )
    );

    // 🟢 Esperar fuentes
    await document.fonts.ready;

    // 🟢 Forzar repintado antes de capturar
    nodo.offsetHeight;
    await new Promise((r) => requestAnimationFrame(r));
    await new Promise((r) => setTimeout(r, 100));

    // 🟢 GENERAR PNG
    const dataUrl = await htmlToImage.toPng(nodo, {
      cacheBust: true,
      useCORS: true,
      pixelRatio: 1,
      style: {
        transform: "scale(1)",
        transformOrigin: "top left",
      },
    });

    // 🟢 PREVIEW LOCAL
    document.getElementById("imagen-preview").src = dataUrl;

    // 🟢 SUBIR AL SERVIDOR
    const blob = await (await fetch(dataUrl)).blob();
    const formData = new FormData();
    formData.append("image", blob, "imagen.png");

    const res = await fetch("https://api.thebrandindustry.com/stanley/grabado.php", {
      method: "POST",
      body: formData,
    });

    const data = await res.json();
    spinner.style.display = "none";

    if (data.success && data.cdnUrl) {
      document.getElementById("imagen-generada").value = data.cdnUrl;
    }

    // Mostrar modal de preview
    document.getElementById("preview-modal").style.display = "flex";

  } catch (err) {
    console.error("❌ Error al generar imagen:", err);
    spinner.style.display = "none";
  }
});

//fin de generar imagen 

function updateVariantId() {
  const selectedColorInput = document.querySelector('.color-selector:checked');
  if (!selectedColorInput) return;

  const selectedVariantId = selectedColorInput.value;

  const variantInput = document.getElementById('selected-variant-id');
  const variantPropertyInput = document.getElementById('selected-idvariante');

  if (selectedVariantId) {
    if (variantInput) variantInput.value = selectedVariantId;
    if (variantPropertyInput) variantPropertyInput.value = selectedVariantId;
    console.log("✅ ID actualizado a:", selectedVariantId);
  } else {
    if (variantInput) variantInput.value = '';
    if (variantPropertyInput) variantPropertyInput.value = '';
    console.warn("⚠️ Ningún variante seleccionado.");
  }
}


document.querySelectorAll('.color-selector').forEach(input => {
  input.addEventListener('change', updateVariantId);
});

document.addEventListener('DOMContentLoaded', updateVariantId);


document.addEventListener('DOMContentLoaded', function () {
  // Función para actualizar el SKU según la variante seleccionada
  function actualizarSKU() {
    const selectedVariantId = document.getElementById('selected-variant-id').value;
    const skuInputs = document.querySelectorAll('.variant-sku');
    const skuField = document.getElementById('form-sku');

    skuInputs.forEach(input => {
      if (input.dataset.variantId === selectedVariantId) {
        skuField.value = input.value;
      }
    });
  }

  // Ejecutar al cargar la página y al cambiar la variante
  actualizarSKU();
  document.getElementById('selected-variant-id').addEventListener('change', actualizarSKU);

  // Manejar el envío del formulario
  document.getElementById('add-to-cart-form').addEventListener('submit', function(e) {
    e.preventDefault();

    const variantPrincipalId = document.getElementById('selected-variant-id').value;

    // 1. Agregar el producto principal sin properties
    const formDataPrincipal = new FormData();
    formDataPrincipal.append('id', variantPrincipalId);

    fetch('/cart/add.js', {
      method: 'POST',
      body: formDataPrincipal
    })
    .then(response => {
      if (response.ok) {
        console.log('✅ Producto principal agregado correctamente.');

        // 2. Obtener campos personalizados
        const texto = document.getElementById('text-input')?.value.trim() || "";

const tipografia = document.querySelector('input[name="properties[Tipografia]"]:checked')?.value || "";

const orientacion = document.querySelector('input[name="properties[Orientación]"]:checked')?.value || "";
;
        const imagen = document.getElementById('imagen-generada').value;
        const sku = document.getElementById('form-sku').value;
        const idvariante = document.getElementById('selected-idvariante').value;

        // Si hay campos personalizados, agregar el producto adicional
        if (texto || tipografia || orientacion || imagen) {
          const productoAdicional = {
            id: 50956046696724, // <-- ID del producto adicional fijo
            quantity: 1,
            properties: {}
          };

          if (texto) productoAdicional.properties["Texto personalizado"] = texto;
          if (tipografia) productoAdicional.properties["Tipografía"] = tipografia;
          if (orientacion) productoAdicional.properties["Orientación"] = orientacion;
          if (imagen) productoAdicional.properties["Imagen generada"] = imagen;
          if (sku) productoAdicional.properties["SKU"] = sku;
          if (idvariante) productoAdicional.properties["ID Variante"] = idvariante;

          return fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(productoAdicional)
          });
        } else {
          return null;
        }
      } else {
        alert('⚠️ No se pudo agregar el producto principal al carrito.');
        return null;
      }
    })
    .then(response => {
      if (response && response.ok) {
        console.log('✅ Producto adicional agregado correctamente.');
      } else if (response) {
        alert('⚠️ El producto adicional no se pudo agregar.');
      }

      // Redirigir al carrito
      window.location.href = '/cart';
    })
    .catch(error => {
      console.log('🟡 Error:', error);
      alert('Ocurrió un problema al agregar los productos. Intenta nuevamente.');
      window.location.href = '/cart';
    });
  });
});

//bloques de imagen y texto
document.addEventListener("DOMContentLoaded", function () {

  // ELEMENTOS
  const textarea = document.getElementById("text-input");
  const textContainer = document.getElementById("text-container");

  const svgBloque = document.getElementById("bloque-svg");

  const button = document.getElementById("generar-imagen");
  const colorRadios = document.querySelectorAll('input[type="radio"][data-img]');
  const mainImage = document.getElementById("main-image");
  const selectedColorText = document.getElementById("selected-color");

  // ESTADOS
  let textOk = false;
  let iconOk = false;
  let imageOk = false;

  // -----------------------------------------
  // VALIDAR BOTÓN
  // -----------------------------------------
  function validarBoton() {
    button.disabled = !((textOk || iconOk) && imageOk);
  }

  // -----------------------------------------
  // 1) ESCRIBIR TEXTO
  // -----------------------------------------
  textarea.addEventListener("input", function () {

    const texto = textarea.value.trim();
    textOk = texto !== "";

    if (textOk) {
      // borrar icono si escriben
      iconOk = false;
      svgBloque.innerHTML = "";

      // 🔥 deseleccionar todos los iconos
      document.querySelectorAll('input[name="svg-icon"]').forEach(r => {
        r.checked = false;
      });
    }

    textContainer.innerText = texto;

    validarBoton();
  });

  // -----------------------------------------
  // 2) SELECCIONAR ICONO SVG
  // -----------------------------------------
  document.querySelectorAll('input[name="svg-icon"]').forEach(input => {

    input.addEventListener("change", function () {

      iconOk = true;

      // borrar texto real
      textarea.value = "";
      textOk = false;

      // borrar texto visible
      textContainer.innerText = "";
      textContainer.style.fontSize = "";

      // limpiar SVG anterior
      svgBloque.innerHTML = "";

      // insertar SVG desde `#svgs-ocultos`
      const icono = document.querySelector('#svgs-ocultos [data-icon="' + this.value + '"]');
      if (icono) {
        svgBloque.innerHTML = icono.innerHTML;
      } else {
        console.warn("No se encontró SVG con data-icon='" + this.value + "'");
      }

      validarBoton();
    });
  });

  // -----------------------------------------
  // 3) CAMBIAR IMAGEN Y COLOR
  // -----------------------------------------
  function updateImageAndColor(radio) {
    const newImageUrl = radio.getAttribute("data-img");
    const colorName = radio.getAttribute("data-color");

    if (newImageUrl) {

      // Si ya es la misma imagen, imageOk = true
      if (mainImage.src === newImageUrl) {
        imageOk = true;
        validarBoton();
        return;
      }

      // Mientras carga, imageOk = false
      imageOk = false;
      validarBoton();

      mainImage.src = newImageUrl;

      mainImage.onload = function () {
        imageOk = true;
        validarBoton();
      };

      mainImage.onerror = function () {
        imageOk = false;
        validarBoton();
        console.error("Error cargando imagen:", newImageUrl);
      };
    }

    if (selectedColorText && colorName) {
      selectedColorText.textContent = colorName;
    }
  }

  // Si hay un color seleccionado al cargar
  const checkedRadio = document.querySelector('input[type="radio"][data-img]:checked');
  if (checkedRadio) {
    updateImageAndColor(checkedRadio);
  }

  // Escuchar cambio de color
  colorRadios.forEach(radio => {
    radio.addEventListener("change", function () {
      updateImageAndColor(this);
    });
  });

});



document.addEventListener('DOMContentLoaded', function () {
  const variantIdInput = document.getElementById('selected-variant-id');
  const skuInput = document.getElementById('form-sku');
  const skuList = document.querySelectorAll('.variant-sku');
  const colorRadios = document.querySelectorAll('.color-selector');

  function updateHiddenFields() {
    const selectedRadio = document.querySelector('.color-selector:checked');
    if (!selectedRadio) return;

    const selectedVariantId = selectedRadio.value;
    variantIdInput.value = selectedVariantId;

    const matchingSKU = Array.from(skuList).find(input =>
      input.dataset.variantId === selectedVariantId
    );

    skuInput.value = matchingSKU ? matchingSKU.value : '';
  }

  // Ejecutar al cambiar el color
  colorRadios.forEach(radio => {
    radio.addEventListener('change', updateHiddenFields);
  });

  // Ejecutar una vez al cargar
  updateHiddenFields();
});




function openCity(evt, cityName) {
  var i, x, tablinks;
  x = document.getElementsByClassName("city");
  for (i = 0; i < x.length; i++) {
    x[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablink");
  for (i = 0; i < x.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" w3-red", "");
  }
  document.getElementById(cityName).style.display = "block";
  evt.currentTarget.className += " w3-red";
}